module.exports = __webpack_public_path__ + "static/media/warning.a6f97c08.ogg";